export default __webpack_public_path__ + "static/media/leftDarkArrow.e0a9263f.svg";